goog.provide('el8.appchart.visitNote.cdsDialog');

goog.require('el8.appchart.dialog.addEditImmunization');
goog.require('el8.appchart.dialog.addEditImmunizationNew');
goog.require('el8.appchart.mgr.orderForm');
goog.require('el8.appshared.message');
goog.require('el8.template.appchart.visitNote.cdsDialog');
goog.require('el8.template.render.decisionSupports');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.util.amplitude.helpers');


/**
 * This is something like a custom QuickSelectDialog,
 * which presents a list of options for addressing a visit note CDS.
 *
 * The options are defined by the server as part of the decisionSupports.js model.
 */
el8.appchart.visitNote.cdsDialog = (function() {

    var item = null; // carries the decisionSupport item
    var noteFormObj = null;
    var resolveCallbackFn = null;

    var that = new el8.uiwidget.NewDialog({
        title: 'Actions to Resolve Clinical Reminder',
        autoHeight: true,
        width: 400,
        modal: true,
        position: 'center',
        contentFn: function() {
            return el8.template.appchart.visitNote.cdsDialog.content();
        },
        showXButton: true
    });

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        that.getContentElt().on('click', '.cds-option',  function(e) {
            var index = $(this).data('index');
            var option = item.getResponseOptions()[index];
            option.actOn(noteFormObj);

            that.hide();
            if (resolveCallbackFn) { resolveCallbackFn(); }
            el8.util.amplitude.logEvent('action to address CDS alert', {
              'action to address CDS': option.getResponseLabel(),
              'document id': el8.appchart.visitNote.main.getNoteId(),
              'CDS measure code': item.getNqfCode()
            });
        });
    };

    var super_show = that.show;
    that.show = function(spec) {
        item = spec.item;
        noteFormObj = spec.noteFormObj;
        resolveCallbackFn = spec.resolveCallbackFn;
        super_show.call(that);
        $('.cds-name', that.getContentElt()).text(item.getPromptLabel());
        $('.cds-actions-content', that.getContentElt()).html(
            el8.template.appchart.visitNote.cdsDialog.options({
                options: item.getResponseOptions().map(el8.model.toSoyMapFn)
            })
        );
        $('.cds-action', that.getContentElt()).addClass('quickSelectButton');
        that.adjustPosition();
    };

    return that;

})();
